import { useState, useEffect } from 'react';
import HeroBgAnimation from '../HeroBgAnimation';
import {
  HeroContainer,
  HeroBg,
  HeroLeftContainer,
  HeroRightContainer,
  HeroInnerContainer,
  TextLoop,
  Title,
  Span,
  SubTitle,
  ResumeButton,
} from './HeroStyle';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';

const HeroSection = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [emoji, setEmoji] = useState('🙋🏻‍♂');

  useEffect(() => {
    let intervalId;
    if (isHovered) {
      intervalId = setInterval(() => {
        setEmoji(prevEmoji => (prevEmoji === '🙋🏻‍♂' ? '👨🏻‍💻' : '🙋🏻‍♂'));
      }, 575);
    } else {
      setEmoji('🙋🏻‍♂');
    }

    return () => clearInterval(intervalId);
  }, [isHovered]);
  return (
    <div id="about">
      <HeroContainer>
        <HeroBg>
          <HeroBgAnimation />
        </HeroBg>
        <HeroInnerContainer>
          <HeroLeftContainer id="Left">
            <Title>
              <span style={{ fontFamily: "'Playfair Display', serif" }}>Hi, I'm </span>
              <span
                style={{
                  background: 'linear-gradient(225deg,rgb(75, 226, 104) 0%,rgb(15, 240, 102) 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontFamily: 'Georgia',
                  cursor: 'none',
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                {Bio.name}
              </span>
              {isHovered && <span>{emoji}</span>}
            </Title>

            <TextLoop>
              <Span>
                <Typewriter
                  options={{
                    strings: Bio.roles,
                    autoStart: true,
                    loop: true,
                  }}
                />
              </Span>
            </TextLoop>
            <SubTitle>{Bio.description}</SubTitle>
            <ResumeButton onClick={() => window.open(Bio.resume, 'display')}>Resume</ResumeButton>
          </HeroLeftContainer>

          <HeroRightContainer id="Right"></HeroRightContainer>
        </HeroInnerContainer>
      </HeroContainer>
    </div>
  );
};

export default HeroSection;
